import { ScrollText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";

export default function BillingContracts() {
  const [, navigate] = useLocation();
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Contracts</h1>
        <p className="text-sm text-muted-foreground">
          Signed agreements between Hoblix and an account — terms, duration, and renewal cadence.
        </p>
      </div>

      <div className="flex flex-col items-center justify-center gap-3 rounded-md border border-dashed bg-muted/30 p-12 text-center">
        <ScrollText className="h-10 w-10 text-muted-foreground/60" />
        <div className="space-y-1">
          <p className="text-sm font-medium">Contracts module is on the roadmap</p>
          <p className="text-xs text-muted-foreground max-w-md">
            For now, the signed agreement lives as a `documents.type='agreement'` row attached to the account.
            View it under <span className="font-medium">Account → Documents</span>.
          </p>
        </div>
        <Button variant="outline" size="sm" onClick={() => navigate("/accounts")}>
          Go to Accounts
        </Button>
      </div>
    </div>
  );
}
